export default {"src":"/_next/static/media/shooting-star-black-white.5950977c.svg","height":270,"width":270,"blurWidth":0,"blurHeight":0};